<div class="product-details-left">
  <div class="product-image-top">
    <swiper
      #swiper
      [initialSlide]="0"
      [slidesPerView]="1"
      [spaceBetween]="0"
      [autoplay]="false"
      [loop]="true"
      [grabCursor]="true"
      [navigation]="true"
      [breakpoints]="{
        '0': {
          slidesPerView: 1,
        },
      }"
      class="mySwiper mySwiperTwo">
      @if (advert.videoUrl) {
        <ng-template swiperSlide>
          <div class="video-frame">
            <video [src]="advert.videoUrl" width="100%" controls></video>
          </div>
        </ng-template>
      }
      @for (imgPath of advert.images; track imgPath) {
        <ng-template swiperSlide>
          <img
            (click)="showImages($index)"
            [src]="imgPath"
            class="product-image"
            alt="Product Image" />
        </ng-template>
      }
    </swiper>
  </div>
  @if (showImgIndex !== undefined) {
    <!-- FIXME: Check this number !== undefined  -->
    <div class="modal" [ngClass]="{ active: showImgIndex !== undefined }">
      <div class="modal-content">
        <swiper
          [initialSlide]="showImgIndex"
          [slidesPerView]="1"
          [spaceBetween]="0"
          [autoplay]="false"
          [loop]="true"
          [grabCursor]="true"
          [navigation]="true"
          [breakpoints]="{
            '0': {
              slidesPerView: 1,
            },
          }"
          class="mySwiper mySwiperTwo">
          @if (advert.videoUrl) {
            <ng-template swiperSlide>
              <div class="video-frame">
                <video
                  class="swiper-product-image"
                  [src]="advert.videoUrl"
                  width="100%"
                  controls></video>
              </div>
            </ng-template>
          }

          @for (imgPath of advert.images; track imgPath) {
            <ng-template swiperSlide>
              <img
                [src]="imgPath"
                class="swiper-product-image"
                alt="Product Image" />
            </ng-template>
          }
        </swiper>
        <span class="close-btn" (click)="closeModal()">&times;</span>
      </div>
    </div>
  }
  <div class="product-image-slider">
    <swiper
      [slidesPerView]="3"
      [spaceBetween]="13"
      [autoplay]="true"
      [grabCursor]="true"
      [navigation]="false"
      [breakpoints]="{
        '520': {
          slidesPerView: 3,
        },
        '768': {
          slidesPerView: 3,
        },
        '900': {
          slidesPerView: 4,
        },
        '1000': {
          slidesPerView: 4,
        },
      }"
      class="mySwiper">
      @if (advert.videoUrl) {
        <ng-template swiperSlide>
          <div class="slide-img">
            <img
              (click)="onSelectImage(-1)"
              [src]="'/assets/images/png/video.png'"
              alt="video" />
          </div>
        </ng-template>
      }

      @for (imgPath of advert.images; track imgPath; let i = $index) {
        <ng-template swiperSlide>
          <div class="slide-img">
            <img (click)="onSelectImage(i)" [src]="imgPath" alt="Image" />
          </div>
        </ng-template>
      }
    </swiper>
  </div>

  <div class="product-details-about">
    <div class="product-details-about-title">
      <h3>About me</h3>
      <div class="product-details-about-listing-details">
        <div class="product-details-about-listing-info">
          <span class="product-details-about-listing-info-heading"
            >Listing created:</span
          >&nbsp;<span class="product-details-about-listing-info-content">{{
            advert.createdAt | date: 'dd-MM-yyyy'
          }}</span>
        </div>
        &nbsp;
        <div class="product-details-about-listing-info">
          <span class="product-details-about-listing-info-heading"
            >Listing refreshed:</span
          >&nbsp;<span class="product-details-about-listing-info-content">{{
            advert.publishDate | date: 'dd-MM-yyyy'
          }}</span>
        </div>
      </div>
    </div>

    <p>
      {{ advert.shortDescription }}
    </p>
  </div>
</div>
